<template>
  <div class="componente-lateral-holder">
    <span v-if="datePub"> <strong>Edição:</strong> {{ datePub }} </span>
    <a href="javascript:void(0)" @click="goToPage">
      <img v-if="image" :src="image" class="image-adjust" />
      <img v-else src="@/assets/imgs/pauta.jpg" />
    </a>
  </div>
</template>

<script>
export default {
  name: 'VideoLateral',
  props: {
    link: {
      type: String,
      default: '',
    },
    newTab: {
      type: [String, Boolean],
      default: false,
    },
    image: {
      type: String,
      required: true,
    },
    datePub: {
      type: String,
      default: '',
    },
  },
  methods: {
    goToPage() {
      const { link, newTab } = this;

      if (!link) return;

      const openNewTab = !!+newTab;

      if (!openNewTab) window.open(link, '_blank');
      else window.open(link, '_self');
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/estilo/sass/_formulas.scss';
@import '@/estilo/sass/_cores.scss';

.componente-lateral-holder {
  position: relative;
  display: flex;
  background: transparent;
  width: 100%;
  height: 200px;
  margin: 0 auto;
  margin-bottom: 5px;
  overflow: hidden;

  & img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  & a {
    width: 100%;
    height: 100%;
  }

  span {
    position: absolute;
    top: 5px;
    right: 5px;
    font-family: 'OpenSans';
    font-size: 11px;
    text-transform: uppercase;
    color: white;
    background: $cor_rosa_dark;
    padding: 2px 10px;
    border-radius: 30px;
  }

  iframe {
    width: 300px;
    height: 185px;
    border: 0px;

    & .ytp-title-channel-logo {
      display: none;
    }
  }
}

.video {
  -webkit-box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.15);
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.15);
}



@media all and (min-width: 300px) and (max-width: 679px) {
  .componente-lateral-holder {
    display: flex;
    align-items: center;
    justify-items: center;
    max-width: calc(100vw - 50px);
    width: calc(100vw - 50px);
    height: 26vh;
    -webkit-box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.45);
    -moz-box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.45);
    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.45);

    & img {
      max-width: calc(100vw - 50px);
      width: calc(100vw - 50px);
      object-fit: cover;
    }

    & iframe {
      width: calc(100vw - 50px);
      height: auto;
    }

    & span {
      top: 3px;
      right: 3px;
      font-size: 8px;
      padding: 1px 5px;
      border-radius: 20px;
    }
  }

  & .video {
    box-shadow: none !important;
  }
}

@media all and (min-width: 680px) and (max-width: 1000px) {
  .componente-lateral-holder {
    -webkit-box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.45);
    -moz-box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.45);
    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.45);
  }
}
</style>
